import React from "react";  

export class DemoComponent extends React.Component{
    constructor(props) {
        super(props)
    }

    render(){
        return <span>Demo Content</span>

    }
}